// Read persisted dark mode preference from localStorage (client-side only)
const getInitialDarkMode = () => {
  if (typeof window === 'undefined') return false;
  try {
    const stored = localStorage.getItem('timbercloud-dark-mode');
    if (stored !== null) return stored === 'true';
    // Fall back to system preference
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches || false;
  } catch {
    return false;
  }
};

const initialState = {
  background: 'light',
  leftSidebar: 'light',
  navbar: 'light',
  rightSidebar: 'light',
  darkMode: false, // Will be hydrated on client
};

export default function palettes(state = initialState, action) {
  switch (action.type) {
    case 'SET_PALETTE':
      return {
        ...state,
        ...action.palette,
      };
    case 'RESET_PALETTES': {
      const variant = state.darkMode ? 'dark' : 'light';
      return {
        ...initialState,
        darkMode: state.darkMode,
        background: variant,
        leftSidebar: variant,
        navbar: variant,
        rightSidebar: variant,
      };
    }
    case 'SET_DARK_MODE': {
      const darkMode = action.value;
      if (typeof window !== 'undefined') {
        try { localStorage.setItem('timbercloud-dark-mode', String(darkMode)); } catch {}
      }
      return {
        ...state,
        darkMode,
        background: darkMode ? 'dark' : 'light',
        leftSidebar: darkMode ? 'dark' : 'light',
        navbar: darkMode ? 'dark' : 'light',
        rightSidebar: darkMode ? 'dark' : 'light',
      };
    }
    case 'TOGGLE_DARK_MODE': {
      const darkMode = !state.darkMode;
      if (typeof window !== 'undefined') {
        try { localStorage.setItem('timbercloud-dark-mode', String(darkMode)); } catch {}
      }
      return {
        ...state,
        darkMode,
        background: darkMode ? 'dark' : 'light',
        leftSidebar: darkMode ? 'dark' : 'light',
        navbar: darkMode ? 'dark' : 'light',
        rightSidebar: darkMode ? 'dark' : 'light',
      };
    }
    case 'SET_DARK_MODE_FROM_SYSTEM': {
      const darkMode = action.value;
      // Don't persist to localStorage — let system preference continue to control
      return {
        ...state,
        darkMode,
        background: darkMode ? 'dark' : 'light',
        leftSidebar: darkMode ? 'dark' : 'light',
        navbar: darkMode ? 'dark' : 'light',
        rightSidebar: darkMode ? 'dark' : 'light',
      };
    }
    case 'HYDRATE_DARK_MODE': {
      const darkMode = getInitialDarkMode();
      return {
        ...state,
        darkMode,
        background: darkMode ? 'dark' : 'light',
        leftSidebar: darkMode ? 'dark' : 'light',
        navbar: darkMode ? 'dark' : 'light',
        rightSidebar: darkMode ? 'dark' : 'light',
      };
    }
    default:
      return state;
  }
}
